import React, { Fragment } from "react";

import GreenLogo from "../Innovators/GreenLogo";
import RedLogo from "../Mentors/RedLogo";
import BlueLogo from "../Employers/BlueLogo";
import RedSpinner from "../../../img/Red_Spinner.gif";

const SubscribeIMECourses = ({ user, setshowSubscription }) => {
  return (
    <Fragment>
      <div className="subscription-overlay">
        {user.role === "innovator" && (
          <div className="subscription-box">
            <i
              className="far fa-times-circle green fa-3x subscription-x"
              onClick={() => setshowSubscription(false)}
            ></i>
            <div className="subscription-type-container">
              <p className="nav-logo">
                <GreenLogo />
              </p>
              <h1 className="subscription-name green">
                Subscription to ime Courses
              </h1>
            </div>
            <form className="subscription-box-container" id="green-scroll">
              <div className="sub-grid-three">
                <div className="sub-container">
                  <div className="sub-user">
                    <div className="online-avi-container">
                      <div className="avi-color-border-alt green">
                        <img
                          src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/Innovate_ME_logo_green.png`}
                          className="sub-avi"
                          alt="avatar"
                        />
                      </div>
                    </div>
                    <div className="online-info">
                      <ul className="user-online-items">
                        <li className="user-online-item">
                          <span className="green name-font bold">ime</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="sub-container">
                  <div className="sub-section-container">
                    <div className="flex-only">
                      <p className="sub-section green">Subtotal</p>
                    </div>
                  </div>
                  <div className="subtotal">
                    <i className="fas fa-dollar-sign mr-5 fa-lg mt-5 green"></i>
                    <p className="total-price white">30.00</p>
                  </div>
                </div>
              </div>
              <div className="sub-grid">
                <div className="sub-section-container">
                  <div className="flex-only">
                    <i className="fas fa-star mr-5 fa-lg mt-5 green"></i>
                    <p className="sub-section green">Benefits</p>
                  </div>
                </div>
                <p className="sub-description">
                  ime Courses grants you access to all active courses for 30
                  days. Explore the many exciting and informational courses that
                  we have to offer now!
                </p>
              </div>
              <div className="billing">
                <div className="sub-section-container-alt">
                  <div className="flex-only">
                    <p className="sub-section green">Payment Methods</p>
                  </div>
                  <div className="flex-only">
                    <i className="fab fa-cc-visa mr-5 mt-5 fa-2x white"></i>
                    <i className="fab fa-cc-mastercard mr-5 mt-5 fa-2x white"></i>
                    <i className="fab fa-cc-jcb mr-5 mt-5 fa-2x white"></i>
                    <i className="fab fa-cc-discover mr-5 mt-5 fa-2x white"></i>
                    <i className="fab fa-cc-diners-club mr-5 mt-5 fa-2x white"></i>
                    <i className="fab fa-cc-amex mt-5 fa-2x white"></i>
                  </div>
                </div>
                <div className="sub-section-container-alt-m">
                  <div className="flex-only">
                    <p className="sub-section green">Billing Information</p>
                  </div>
                </div>
                <div className="sub-grid-two">
                  <div className="input-grid">
                    <label htmlFor="firstname" className="green bold block">
                      *First Name
                    </label>
                    <div className="error-container">
                      <i className="fas fa-exclamation my-auto red"></i>{" "}
                      <p className="text white">Please enter your first name</p>
                    </div>
                    <input
                      className="sub-input"
                      type="text"
                      name="firstname"
                      placeholder="Enter First Name"
                    />
                  </div>
                  <div className="input-grid">
                    <label htmlFor="lastname" className="green bold block">
                      *Last Name
                    </label>
                    <div className="error-container">
                      <i className="fas fa-exclamation my-auto red"></i>{" "}
                      <p className="text white">Please enter your last name</p>
                    </div>
                    <input
                      className="sub-input"
                      type="text"
                      name="lastname"
                      placeholder="Enter Last Name"
                    />
                  </div>
                </div>
                <div className="sub-grid-three">
                  <div className="input-grid">
                    <label htmlFor="address" className="green bold block">
                      *Address
                    </label>
                    <div className="error-container">
                      <i className="fas fa-exclamation my-auto red"></i>{" "}
                      <p className="text white">
                        Please enter your billing address
                      </p>
                    </div>
                    <input
                      className="sub-input"
                      type="text"
                      name="address"
                      placeholder="Enter Address"
                    />
                  </div>
                  <div className="input-grid">
                    <label htmlFor="country" className="green bold block">
                      *Country
                    </label>
                    <select name="country">
                      <option value="UntitedStates">United States</option>
                      <option value="Australia">Australia</option>
                      <option value="Belgium">Belgium</option>
                      <option value="Brazil">Brazil</option>
                      <option value="Bulgaria">Bulgaria</option>
                      <option value="Canada">Canada</option>
                      <option value="Cyprus">Cyprus</option>
                      <option value="CzechRepublic">Czech Republic</option>
                      <option value="Denmark">Denmark</option>
                      <option value="Estonia">Estonia</option>
                      <option value="Finland">Finland</option>
                      <option value="France">France</option>
                      <option value="Germany">Germany</option>
                      <option value="Greece">Greece</option>
                      <option value="HongKong">Hong Kong</option>
                      <option value="Hungary">Hungary</option>
                      <option value="India">India</option>
                      <option value="Ireland">Ireland</option>
                      <option value="Italy">Italy</option>
                      <option value="Japan">Japan</option>
                      <option value="Latvia">Latvia</option>
                      <option value="Lithuania">Lithuania</option>
                      <option value="Luxembourg">Luxembourg</option>
                      <option value="Malaysia">Malaysia</option>
                      <option value="Malta">Malta</option>
                      <option value="Mexico">Mexico</option>
                      <option value="Netherlands">Netherlands</option>
                      <option value="NewZealand">New Zealand</option>
                      <option value="Norway">Norway</option>
                      <option value="Poland">Poland</option>
                      <option value="Portugal">Portugal</option>
                      <option value="Romania">Romania</option>
                      <option value="Singapore">Singapore</option>
                      <option value="Slovakia">Slovakia</option>
                      <option value="Slovenia">Slovenia</option>
                      <option value="Spain">Spain</option>
                      <option value="Sweden">Sweden</option>
                      <option value="Switzerland">Switzerland</option>
                      <option value="UnitedKingdom">United Kingdom</option>
                    </select>
                  </div>
                </div>
                <div className="sub-grid-three-alt">
                  <div className="input-grid">
                    <label htmlFor="city" className="green bold block">
                      *City
                    </label>
                    <div className="error-container">
                      <i className="fas fa-exclamation my-auto red"></i>{" "}
                      <p className="text white">Please enter city</p>
                    </div>
                    <input
                      className="sub-input"
                      type="text"
                      name="city"
                      placeholder="Enter City"
                    />
                  </div>
                  <div className="input-grid">
                    <label
                      htmlFor="state/providence"
                      className="green bold block"
                    >
                      *State/Providence
                    </label>
                    <div className="error-container">
                      <i className="fas fa-exclamation my-auto red"></i>{" "}
                      <p className="text white">
                        Please enter state/providence
                      </p>
                    </div>
                    <input
                      className="sub-input"
                      type="text"
                      name="state/providence"
                      placeholder="Enter State/Providence"
                    />
                  </div>
                  <div className="input-grid">
                    <label htmlFor="zip" className="green bold block">
                      *Zip Code
                    </label>
                    <div className="error-container">
                      <i className="fas fa-exclamation my-auto red"></i>{" "}
                      <p className="text white">Please enter zip code</p>
                    </div>
                    <input
                      className="sub-input"
                      type="text"
                      name="zip"
                      placeholder="Enter Zip Code"
                    />
                  </div>
                </div>
                <div className="sub-section-container-alt-m">
                  <div className="flex-only">
                    <p className="sub-section green">Card Information</p>
                  </div>
                </div>
                <div className="sub-grid-four">
                  <div className="input-grid">
                    <label htmlFor="cardnumber" className="green bold block">
                      *Card Number
                    </label>
                    <div className="error-container">
                      <i className="fas fa-exclamation my-auto red"></i>{" "}
                      <p className="text white">
                        Please enter a valid card number
                      </p>
                    </div>
                    <input
                      className="sub-input"
                      type="text"
                      name="cardnumber"
                      placeholder="Enter Card Number"
                    />
                  </div>
                  <div className="input-grid">
                    <label htmlFor="month" className="green bold block">
                      *Month
                    </label>
                    <select name="month">
                      <option value="01">01</option>
                      <option value="02">02</option>
                      <option value="03">03</option>
                      <option value="04">04</option>
                      <option value="05">05</option>
                      <option value="06">06</option>
                      <option value="07">07</option>
                      <option value="08">08</option>
                      <option value="09">09</option>
                      <option value="10">10</option>
                      <option value="11">11</option>
                      <option value="12">12</option>
                    </select>
                  </div>
                  <div className="input-grid">
                    <label htmlFor="year" className="green bold block">
                      *Year
                    </label>
                    <select name="year">
                      <option value="01">2021</option>
                      <option value="02">2022</option>
                      <option value="03">2023</option>
                      <option value="04">2024</option>
                    </select>
                  </div>
                  <div className="input-grid">
                    <label htmlFor="cvv" className="green bold block">
                      *CVV
                    </label>
                    <div className="error-container">
                      <i className="fas fa-exclamation my-auto red"></i>{" "}
                      <p className="text white">
                        Please enter card security code
                      </p>
                    </div>
                    <input
                      className="sub-input"
                      type="text"
                      name="cvv"
                      placeholder="CVV"
                    />
                  </div>
                </div>
                <button className="purchase-sub background-green">
                  Purchase
                </button>
              </div>
            </form>
          </div>
        )}
        {user.role === "mentor" && (
          <div className="subscription-box">
            {/* {processing && (
              <div className="spinner-overlay">
                <img src={RedSpinner} alt="spinner-position" />
              </div>
            )} */}
            <i
              className="far fa-times-circle red fa-3x subscription-x"
              onClick={() => setshowSubscription(false)}
            ></i>
            <div className="subscription-type-container">
              <p className="nav-logo">
                <RedLogo />
              </p>
              <h1 className="subscription-name red">
                Subscription to ime Courses
              </h1>
            </div>
            <form className="subscription-box-container" id="red-scroll">
              <div className="sub-grid-three">
                <div className="sub-container">
                  <div className="sub-user">
                    <div className="online-avi-container">
                      <div className="avi-color-border-alt red">
                        <img
                          src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/mentors/Innovate_Me_logo_red.png`}
                          className="sub-avi"
                          alt="sub-avatar"
                        />
                      </div>
                    </div>
                    <div className="online-info">
                      <ul className="user-online-items">
                        <li className="user-online-item">
                          <span className="red name-font bold">ime</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="sub-container">
                  <div className="sub-section-container">
                    <div className="flex-only">
                      <p className="sub-section red">Subtotal</p>
                    </div>
                  </div>
                  <div className="subtotal">
                    <i className="fas fa-dollar-sign mr-5 fa-lg mt-5 red"></i>
                    <p className="total-price white">30.00</p>
                  </div>
                </div>
              </div>
              <div className="sub-grid">
                <div className="sub-section-container">
                  <div className="flex-only">
                    <i className="fas fa-star mr-5 fa-lg mt-5 red"></i>
                    <p className="sub-section red">Benefits</p>
                  </div>
                </div>
                <p className="sub-description">
                  ime Courses grants you access to all active courses for 30
                  days. Explore the many exciting and informational courses that
                  we have to offer now!
                </p>
              </div>
              <div className="billing">
                <div className="sub-section-container-alt">
                  <div className="flex-only">
                    <p className="sub-section red">Payment Methods</p>
                  </div>
                  <div className="flex-only">
                    <i className="fab fa-cc-visa mr-5 mt-5 fa-2x white"></i>
                    <i className="fab fa-cc-mastercard mr-5 mt-5 fa-2x white"></i>
                    <i className="fab fa-cc-jcb mr-5 mt-5 fa-2x white"></i>
                    <i className="fab fa-cc-discover mr-5 mt-5 fa-2x white"></i>
                    <i className="fab fa-cc-diners-club mr-5 mt-5 fa-2x white"></i>
                    <i className="fab fa-cc-amex mt-5 fa-2x white"></i>
                  </div>
                </div>
                <div className="sub-section-container-alt-m">
                  <div className="flex-only">
                    <p className="sub-section red">Billing Information</p>
                  </div>
                </div>
                <div className="sub-grid-two">
                  <div className="input-grid">
                    <label htmlFor="firstname" className="red bold block">
                      *First Name
                    </label>
                    <div className="error-container">
                      <i className="fas fa-exclamation my-auto red"></i>{" "}
                      <p className="text white">Please enter your first name</p>
                    </div>
                    <input
                      className="sub-input"
                      type="text"
                      name="firstname"
                      placeholder="Enter First Name"
                    />
                  </div>
                  <div className="input-grid">
                    <label htmlFor="lastname" className="red bold block">
                      *Last Name
                    </label>
                    <div className="error-container">
                      <i className="fas fa-exclamation my-auto red"></i>{" "}
                      <p className="text white">Please enter your last name</p>
                    </div>
                    <input
                      className="sub-input"
                      type="text"
                      name="lastname"
                      placeholder="Enter Last Name"
                    />
                  </div>
                </div>
                <div className="sub-grid-three">
                  <div className="input-grid">
                    <label htmlFor="address" className="red bold block">
                      *Address
                    </label>
                    <div className="error-container">
                      <i className="fas fa-exclamation my-auto red"></i>{" "}
                      <p className="text white">
                        Please enter your billing address
                      </p>
                    </div>
                    <input
                      className="sub-input"
                      type="text"
                      name="address"
                      placeholder="Enter Address"
                    />
                  </div>
                  <div className="input-grid">
                    <label htmlFor="country" className="red bold block">
                      *Country
                    </label>
                    <select name="country">
                      <option value="UntitedStates">United States</option>
                      <option value="Australia">Australia</option>
                      <option value="Belgium">Belgium</option>
                      <option value="Brazil">Brazil</option>
                      <option value="Bulgaria">Bulgaria</option>
                      <option value="Canada">Canada</option>
                      <option value="Cyprus">Cyprus</option>
                      <option value="CzechRepublic">Czech Republic</option>
                      <option value="Denmark">Denmark</option>
                      <option value="Estonia">Estonia</option>
                      <option value="Finland">Finland</option>
                      <option value="France">France</option>
                      <option value="Germany">Germany</option>
                      <option value="Greece">Greece</option>
                      <option value="HongKong">Hong Kong</option>
                      <option value="Hungary">Hungary</option>
                      <option value="India">India</option>
                      <option value="Ireland">Ireland</option>
                      <option value="Italy">Italy</option>
                      <option value="Japan">Japan</option>
                      <option value="Latvia">Latvia</option>
                      <option value="Lithuania">Lithuania</option>
                      <option value="Luxembourg">Luxembourg</option>
                      <option value="Malaysia">Malaysia</option>
                      <option value="Malta">Malta</option>
                      <option value="Mexico">Mexico</option>
                      <option value="Netherlands">Netherlands</option>
                      <option value="NewZealand">New Zealand</option>
                      <option value="Norway">Norway</option>
                      <option value="Poland">Poland</option>
                      <option value="Portugal">Portugal</option>
                      <option value="Romania">Romania</option>
                      <option value="Singapore">Singapore</option>
                      <option value="Slovakia">Slovakia</option>
                      <option value="Slovenia">Slovenia</option>
                      <option value="Spain">Spain</option>
                      <option value="Sweden">Sweden</option>
                      <option value="Switzerland">Switzerland</option>
                      <option value="UnitedKingdom">United Kingdom</option>
                    </select>
                  </div>
                </div>
                <div className="sub-grid-three-alt">
                  <div className="input-grid">
                    <label htmlFor="city" className="red bold block">
                      *City
                    </label>
                    <div className="error-container">
                      <i className="fas fa-exclamation my-auto red"></i>{" "}
                      <p className="text white">Please enter city</p>
                    </div>
                    <input
                      className="sub-input"
                      type="text"
                      name="city"
                      placeholder="Enter City"
                    />
                  </div>
                  <div className="input-grid">
                    <label
                      htmlFor="state/providence"
                      className="red bold block"
                    >
                      *State/Providence
                    </label>
                    <div className="error-container">
                      <i className="fas fa-exclamation my-auto red"></i>{" "}
                      <p className="text white">
                        Please enter state/providence
                      </p>
                    </div>
                    <input
                      className="sub-input"
                      type="text"
                      name="state/providence"
                      placeholder="Enter State/Providence"
                    />
                  </div>
                  <div className="input-grid">
                    <label htmlFor="zip" className="red bold block">
                      *Zip Code
                    </label>
                    <div className="error-container">
                      <i className="fas fa-exclamation my-auto red"></i>{" "}
                      <p className="text white">Please enter zip code</p>
                    </div>
                    <input
                      className="sub-input"
                      type="text"
                      name="zip"
                      placeholder="Enter Zip Code"
                    />
                  </div>
                </div>
                <div className="sub-section-container-alt-m">
                  <div className="flex-only">
                    <p className="sub-section red">Card Information</p>
                  </div>
                </div>
                <div className="sub-grid-four">
                  <div className="input-grid">
                    <label htmlFor="cardnumber" className="red bold block">
                      *Card Number
                    </label>
                    <div className="error-container">
                      <i className="fas fa-exclamation my-auto red"></i>{" "}
                      <p className="text white">
                        Please enter a valid card number
                      </p>
                    </div>
                    <input
                      className="sub-input"
                      type="text"
                      name="cardnumber"
                      placeholder="Enter Card Number"
                    />
                  </div>
                  <div className="input-grid">
                    <label htmlFor="month" className="red bold block">
                      *Month
                    </label>
                    <select name="month">
                      <option value="01">01</option>
                      <option value="02">02</option>
                      <option value="03">03</option>
                      <option value="04">04</option>
                      <option value="05">05</option>
                      <option value="06">06</option>
                      <option value="07">07</option>
                      <option value="08">08</option>
                      <option value="09">09</option>
                      <option value="10">10</option>
                      <option value="11">11</option>
                      <option value="12">12</option>
                    </select>
                  </div>
                  <div className="input-grid">
                    <label htmlFor="year" className="red bold block">
                      *Year
                    </label>
                    <select name="year">
                      <option value="01">2021</option>
                      <option value="02">2022</option>
                      <option value="03">2023</option>
                      <option value="04">2024</option>
                    </select>
                  </div>
                  <div className="input-grid">
                    <label htmlFor="cvv" className="red bold block">
                      *CVV
                    </label>
                    <div className="error-container">
                      <i className="fas fa-exclamation my-auto red"></i>{" "}
                      <p className="text white">
                        Please enter card security code
                      </p>
                    </div>
                    <input
                      className="sub-input"
                      type="text"
                      name="cvv"
                      placeholder="CVV"
                    />
                  </div>
                </div>
                <button className="purchase-sub background-red">
                  Purchase
                </button>
              </div>
            </form>
          </div>
        )}
        {user.role === "employer" && (
          <div className="subscription-box">
            <i
              className="far fa-times-circle blue fa-3x subscription-x"
              onClick={() => setshowSubscription(false)}
            ></i>
            <div className="subscription-type-container">
              <p className="nav-logo">
                <BlueLogo />
              </p>
              <h1 className="subscription-name blue">
                Subscription to ime Courses
              </h1>
            </div>
            <form className="subscription-box-container" id="blue-scroll">
              <div className="sub-grid-three">
                <div className="sub-container">
                  <div className="sub-user">
                    <div className="online-avi-container">
                      <div className="avi-color-border-alt blue">
                        <img
                          src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/employers/Innovate_Me_logo_blue.png`}
                          className="sub-avi"
                          alt="employer-avatar"
                        />
                      </div>
                    </div>
                    <div className="online-info">
                      <ul className="user-online-items">
                        <li className="user-online-item">
                          <span className="blue name-font bold">ime</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="sub-container">
                  <div className="sub-section-container">
                    <div className="flex-only">
                      <p className="sub-section blue">Subtotal</p>
                    </div>
                  </div>
                  <div className="subtotal">
                    <i className="fas fa-dollar-sign mr-5 fa-lg mt-5 blue"></i>
                    <p className="total-price white">30.00</p>
                  </div>
                </div>
              </div>
              <div className="sub-grid">
                <div className="sub-section-container">
                  <div className="flex-only">
                    <i className="fas fa-star mr-5 fa-lg mt-5 blue"></i>
                    <p className="sub-section blue">Benefits</p>
                  </div>
                </div>
                <p className="sub-description">
                  ime Courses grants you access to all active courses for 30
                  days. Explore the many exciting and informational courses that
                  we have to offer now!
                </p>
              </div>
              <div className="billing">
                <div className="sub-section-container-alt">
                  <div className="flex-only">
                    <p className="sub-section blue">Payment Methods</p>
                  </div>
                  <div className="flex-only">
                    <i className="fab fa-cc-visa mr-5 mt-5 fa-2x white"></i>
                    <i className="fab fa-cc-mastercard mr-5 mt-5 fa-2x white"></i>
                    <i className="fab fa-cc-jcb mr-5 mt-5 fa-2x white"></i>
                    <i className="fab fa-cc-discover mr-5 mt-5 fa-2x white"></i>
                    <i className="fab fa-cc-diners-club mr-5 mt-5 fa-2x white"></i>
                    <i className="fab fa-cc-amex mt-5 fa-2x white"></i>
                  </div>
                </div>
                <div className="sub-grid-two">
                  <div className="input-grid">
                    <label htmlFor="firstname" className="blue bold block">
                      *First Name
                    </label>
                    <div className="error-container">
                      <i className="fas fa-exclamation my-auto red"></i>{" "}
                      <p className="text white">Please enter your first name</p>
                    </div>
                    <input
                      className="sub-input"
                      type="text"
                      name="firstname"
                      placeholder="Enter First Name"
                    />
                  </div>
                  <div className="input-grid">
                    <label htmlFor="lastname" className="blue bold block">
                      *Last Name
                    </label>
                    <div className="error-container">
                      <i className="fas fa-exclamation my-auto red"></i>{" "}
                      <p className="text white">Please enter your last name</p>
                    </div>
                    <input
                      className="sub-input"
                      type="text"
                      name="lastname"
                      placeholder="Enter Last Name"
                    />
                  </div>
                </div>
                <div className="sub-grid-three">
                  <div className="input-grid">
                    <label htmlFor="address" className="blue bold block">
                      *Address
                    </label>
                    <div className="error-container">
                      <i className="fas fa-exclamation my-auto red"></i>{" "}
                      <p className="text white">
                        Please enter your billing address
                      </p>
                    </div>
                    <input
                      className="sub-input"
                      type="text"
                      name="address"
                      placeholder="Enter Address"
                    />
                  </div>
                  <div className="input-grid">
                    <label htmlFor="country" className="blue bold block">
                      *Country
                    </label>
                    <select name="country">
                      <option value="UntitedStates">United States</option>
                      <option value="Australia">Australia</option>
                      <option value="Belgium">Belgium</option>
                      <option value="Brazil">Brazil</option>
                      <option value="Bulgaria">Bulgaria</option>
                      <option value="Canada">Canada</option>
                      <option value="Cyprus">Cyprus</option>
                      <option value="CzechRepublic">Czech Republic</option>
                      <option value="Denmark">Denmark</option>
                      <option value="Estonia">Estonia</option>
                      <option value="Finland">Finland</option>
                      <option value="France">France</option>
                      <option value="Germany">Germany</option>
                      <option value="Greece">Greece</option>
                      <option value="HongKong">Hong Kong</option>
                      <option value="Hungary">Hungary</option>
                      <option value="India">India</option>
                      <option value="Ireland">Ireland</option>
                      <option value="Italy">Italy</option>
                      <option value="Japan">Japan</option>
                      <option value="Latvia">Latvia</option>
                      <option value="Lithuania">Lithuania</option>
                      <option value="Luxembourg">Luxembourg</option>
                      <option value="Malaysia">Malaysia</option>
                      <option value="Malta">Malta</option>
                      <option value="Mexico">Mexico</option>
                      <option value="Netherlands">Netherlands</option>
                      <option value="NewZealand">New Zealand</option>
                      <option value="Norway">Norway</option>
                      <option value="Poland">Poland</option>
                      <option value="Portugal">Portugal</option>
                      <option value="Romania">Romania</option>
                      <option value="Singapore">Singapore</option>
                      <option value="Slovakia">Slovakia</option>
                      <option value="Slovenia">Slovenia</option>
                      <option value="Spain">Spain</option>
                      <option value="Sweden">Sweden</option>
                      <option value="Switzerland">Switzerland</option>
                      <option value="UnitedKingdom">United Kingdom</option>
                    </select>
                  </div>
                </div>
                <div className="sub-grid-three-alt-subscribe">
                  <div className="input-grid">
                    <label htmlFor="city" className="blue bold block">
                      *City
                    </label>
                    <div className="error-container">
                      <i className="fas fa-exclamation my-auto red"></i>{" "}
                      <p className="text white">Please enter city</p>
                    </div>
                    <input
                      className="sub-input"
                      type="text"
                      name="city"
                      placeholder="Enter City"
                    />
                  </div>
                  <div className="input-grid">
                    <label
                      htmlFor="state/providence"
                      className="blue bold block"
                    >
                      *State/Providence
                    </label>
                    <div className="error-container">
                      <i className="fas fa-exclamation my-auto red"></i>{" "}
                      <p className="text white">
                        Please enter state/providence
                      </p>
                    </div>
                    <input
                      className="sub-input"
                      type="text"
                      name="state/providence"
                      placeholder="Enter State/Providence"
                    />
                  </div>
                  <div className="input-grid">
                    <label htmlFor="zip" className="blue bold block">
                      *Zip Code
                    </label>
                    <div className="error-container">
                      <i className="fas fa-exclamation my-auto red"></i>{" "}
                      <p className="text white">Please enter zip code</p>
                    </div>
                    <input
                      className="sub-input"
                      type="text"
                      name="zip"
                      placeholder="Enter Zip Code"
                    />
                  </div>
                </div>
                <div className="sub-section-container-alt-m">
                  <div className="flex-only">
                    <p className="sub-section blue">Card Information</p>
                  </div>
                </div>
                <div className="sub-grid-four">
                  <div className="input-grid">
                    <label htmlFor="cardnumber" className="blue bold block">
                      *Card Number
                    </label>
                    <div className="error-container">
                      <i className="fas fa-exclamation my-auto red"></i>{" "}
                      <p className="text white">
                        Please enter a valid card number
                      </p>
                    </div>
                    <input
                      className="sub-input"
                      type="text"
                      name="cardnumber"
                      placeholder="Enter Card Number"
                    />
                  </div>
                  <div className="input-grid">
                    <label htmlFor="month" className="blue bold block">
                      *Month
                    </label>
                    <select name="month">
                      <option value="01">01</option>
                      <option value="02">02</option>
                      <option value="03">03</option>
                      <option value="04">04</option>
                      <option value="05">05</option>
                      <option value="06">06</option>
                      <option value="07">07</option>
                      <option value="08">08</option>
                      <option value="09">09</option>
                      <option value="10">10</option>
                      <option value="11">11</option>
                      <option value="12">12</option>
                    </select>
                  </div>
                  <div className="input-grid">
                    <label htmlFor="year" className="blue bold block">
                      *Year
                    </label>
                    <select name="year">
                      <option value="01">2021</option>
                      <option value="02">2022</option>
                      <option value="03">2023</option>
                      <option value="04">2024</option>
                    </select>
                  </div>
                  <div className="input-grid">
                    <label htmlFor="cvv" className="blue bold block">
                      *CVV
                    </label>
                    <div className="error-container">
                      <i className="fas fa-exclamation my-auto red"></i>{" "}
                      <p className="text white">
                        Please enter card security code
                      </p>
                    </div>
                    <input
                      className="sub-input"
                      type="text"
                      name="cvv"
                      placeholder="CVV"
                    />
                  </div>
                </div>
                <button className="purchase-sub background-blue">
                  Purchase
                </button>
              </div>
            </form>
          </div>
        )}
      </div>
    </Fragment>
  );
};

export default SubscribeIMECourses;
